// extracted by mini-css-extract-plugin
module.exports = {"PlaceholderCard":"PlaceholderCard-module--PlaceholderCard--mOjRV"};